import Cookies from 'js-cookie';
import { LoginAccountType, NEED_JUMP_PATH, LoginType, DEFAULT_URS_INCLUDE_ID, USER_ACCOUNT_URL, URS_LANG_CONFIG_MAP_ZH, URS_LANG_CONFIG_MAP_EN } from '../constants/login.js';
import '../constants/activity.js';
import { isNode } from '../constants/common.js';
import { LANG_LOCAL_STORAGE_KEY, EN, ZH } from '../constants/locale.js';
import { LOGIN_BASE_URL, WX_USER_ACCOUNT_URL } from '../constants/request.js';
import { getQueryString, setCookie } from './common.js';

const checkIsYaotaiInternalUser = (login_type) => {
    return [LoginAccountType.Openid].includes(login_type);
};
const CheckIsYaotaiWeixinUser = (login_type) => {
    return [LoginAccountType.Weixin].includes(login_type);
};
const checkIsYaotaiUser = (login_type) => {
    return login_type && !checkIsYaotaiInternalUser(login_type);
};
const ifJumpToTargetPage = (next) => NEED_JUMP_PATH.find(item => next?.includes(item));
function rbacUrsCheck({ rbac_server, url, username, jumpPathConfig, }) {
    const next = getQueryString('next');
    const needToJumpPath = ifJumpToTargetPage(next);
    const _url = needToJumpPath && jumpPathConfig ? jumpPathConfig[needToJumpPath] : next || url;
    window.location.href = `${window.location.origin}/rbac/urscheck?path=${_url}&username=${(username || '').split('-').slice(-1)[0]}&server=${rbac_server}`;
}
// NOTE: 自定义的用于严格判断是 163 邮箱的 Cookie
function setNeteaseCookieDomain(customDomain) {
    if (customDomain) {
        Cookies.set('RBAC_NETEASE', '1', { path: '/', domain: customDomain });
    }
    else {
        Cookies.set('RBAC_NETEASE', '1', { path: '/' });
    }
}
const setUserAccountToken = ({ RBAC_USER, RBAC_TOKEN, cookieDomain, }) => {
    if (RBAC_USER && RBAC_TOKEN) {
        const danluDomain = '.danlu.netease.com';
        Cookies.remove('RBAC_TOKEN', { path: '/', domain: danluDomain });
        Cookies.remove('RBAC_USER', { path: '/', domain: danluDomain });
        setCookie({
            name: 'RBAC_USER',
            value: RBAC_USER,
            domain: cookieDomain,
        });
        setCookie({
            name: 'RBAC_TOKEN',
            value: RBAC_TOKEN,
            domain: cookieDomain,
        });
    }
};
const loginByWechat = ({ rbacUrl, url, rbac_server, }) => {
    let _url = url || getQueryString('next') || (isNode ? '/' : window.location.href);
    if (!isNode) {
        window.location.href = `${rbacUrl}/wxlogin?next=${_url}&server=${rbac_server}&lang=${window.localStorage.getItem(LANG_LOCAL_STORAGE_KEY) === EN ? 'en' : 'cn'}`;
        localStorage.setItem('FROM-LOGIN', 'true');
    }
};
const loginByWechatMobile = ({ rbacUrl = 'https://rbac-dev.apps.danlu.netease.com', url, portHost, wechatUrl, }) => {
    let _url = url || getQueryString('next') || (isNode ? '/' : window.location.href);
    // 正常有微信授权域名的地址
    let _redirect_uri = `${portHost}${WX_USER_ACCOUNT_URL}?next_url=${_url}`;
    // 这里的 isNew 用于标识是在 3.1.0 版本及之后的
    const redirect_uri = wechatUrl ? `${wechatUrl}?next_url=${_url}&is_new=true` : _redirect_uri;
    if (!isNode) {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0df60dd198331092&redirect_uri=${encodeURIComponent(redirect_uri)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    }
};
const loginByGoogle = ({ rbacUrl, url, rbac_server, }) => {
    let _url = url || getQueryString('next') || (isNode ? '/' : window.location.href);
    if (!isNode) {
        window.location.href = `${rbacUrl}/google_login?next=${_url}&server=${rbac_server}`;
        localStorage.setItem('FROM-LOGIN', 'true');
    }
};
const getLocaleConfig = (language) => {
    switch (language) {
        case EN:
            return URS_LANG_CONFIG_MAP_EN;
        default:
            return URS_LANG_CONFIG_MAP_ZH;
    }
};
// eslint-disable-next-line react-func/max-lines-per-function
function initUrs({ id = DEFAULT_URS_INCLUDE_ID, regcb, logincb, cssDomain, cssFiles, cookieDomain, regCookieDomain, language, changepage, page = 'login', }) {
    if (isNode)
        return;
    if (!window?.URS)
        return;
    if (document.getElementById(id)?.childElementCount) {
        document.getElementById(id).innerHTML = '';
    }
    const _language = language || localStorage.getItem(LANG_LOCAL_STORAGE_KEY) || ZH;
    const loginType = getQueryString('type') || LoginType.Phone;
    const isPhoneLogin = loginType === LoginType.Phone;
    new URS({
        newCDN: 1,
        version: 4,
        cssDomain,
        cssFiles,
        includeBox: id,
        product: 'rbac',
        promark: 'PFvqXFU',
        host: 'rbac.fuxi.netease.com',
        page,
        changepage,
        mobileFirst: 1,
        needMobileLogin: isPhoneLogin ? 1 : 0,
        needMobileReg: 0,
        smsLoginFirst: 1,
        cookieDomain,
        regCookieDomain,
        uniteLogin: {
            isItl: 1,
        },
        mbNeedItl: 1,
        mbCanLoginGuide: 1,
        skin: 1,
        regcb,
        logincb,
        ...getLocaleConfig(_language),
    });
}
const getCustomUserInfoUrl = ({ gateWayUrl }) => {
    return `${gateWayUrl ? gateWayUrl : ''}${LOGIN_BASE_URL}${USER_ACCOUNT_URL}`;
};

export { CheckIsYaotaiWeixinUser, checkIsYaotaiInternalUser, checkIsYaotaiUser, getCustomUserInfoUrl, ifJumpToTargetPage, initUrs, loginByGoogle, loginByWechat, loginByWechatMobile, rbacUrsCheck, setNeteaseCookieDomain, setUserAccountToken };
